import { memo, useMemo } from 'react';
import { Box, Image } from '@betty/moonlight';
import { StatusBoxWithGemProps } from './types';
import { statusGemMap } from '../content/status.content';

function StatusBoxWithGem({ statusName, isOnlyItem }: StatusBoxWithGemProps) {
  const GemImage = useMemo(
    () =>
      statusName === 'Member' || isOnlyItem ? null : (
        <Image
          position="absolute"
          right="space-0"
          bottom="space-0"
          name={statusGemMap[statusName]}
          height="space-300"
          width="space-300"
        />
      ),
    [statusName, isOnlyItem],
  );

  const boxSize = useMemo(
    () => (isOnlyItem ? 'space-3000' : 'space-1000'),
    [isOnlyItem],
  );

  return (
    <Box position="relative">
      <Image name="common.BettyBoxLocked" width={boxSize} height={boxSize} />
      {GemImage}
    </Box>
  );
}

export default memo(StatusBoxWithGem);
